module.exports = __webpack_public_path__ + "fonts/modal-aside.svg";